/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Delete, Edit } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import WasteDialog from './WasteDialog';
import { getWastesApi } from '../../../api/stocks/waste/wasteApi';
import ItemWasteDialog from './ItemWasteDialog';
import { NestedTableCell } from './Styled-components';
import { TopBox } from '../../Shared/shared';

export default function Waste() {
  const [openDialog, setOpenDialog] = useState({ isOpen: false, id: '' });
  const [openItemDialog, setOpenItemDialog] = useState({
    isOpen: false,
    id: ''
  });

  const params = useParams();
  const obj = params;
  const outletstr = obj['*']; // gets the string "outlet/skp/pos"
  const str = outletstr;
  const parts = str.split('/');
  const code = parts[1]; // gets the text "skp"

  const outlet = useSelector((state) =>
    state.authorize?.loginResponse?.user?.outlets?.find(
      (outlet) => outlet.code.toLowerCase() === code
    )
  );

  const [wastesData, setWastesData] = useState([]);

  const getWastes = async () => {
    const res = await getWastesApi(outlet._id);
    setWastesData(res?.data);
  };

  // handling inner tables
  const [openRows, setOpenRows] = useState(
    Array(wastesData.length).fill(false)
  );

  const handleRowClick = (index) => {
    const newOpenRows = [...openRows];
    newOpenRows[index] = !newOpenRows[index];
    setOpenRows(newOpenRows);
  };

  // pagination
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(20);

  function handleChangePage(event, newpage) {
    setpg(newpage);
  }

  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }

  const callFunc = () => {
    getWastes();
  };

  useEffect(() => {
    getWastes();
  }, []);

  return (
    <>
      <TopBox>
        <Typography sx={{ fontSize: '20px', fontWeight: 700 }}>
          Waste Managment
        </Typography>

        <Tooltip title="Add Item Waste">
          <Button
            style={{
              backgroundColor: '#66C8E0'
            }}
            onClick={() => {
              setOpenItemDialog({ isOpen: true });
            }}>
            <AddIcon />
            <Typography sx={{ lineHeight: '0', letterSpacing: '0' }}>
              Add Item Waste
            </Typography>
          </Button>
        </Tooltip>
        <Tooltip title="Add Ingredient Waste">
          <Button
            style={{
              backgroundColor: '#66C8E0'
            }}
            onClick={() => {
              setOpenDialog({ isOpen: true });
            }}>
            <AddIcon />
            <Typography sx={{ lineHeight: '0', letterSpacing: '0' }}>
              Add Ingredient Waste
            </Typography>
          </Button>
        </Tooltip>
      </TopBox>

      {!wastesData ? (
        <Box
          sx={{
            height: 'max-content'
          }}>
          {[...Array(10)].map((arr, i) => (
            <Skeleton key={i} variant="rectangular" sx={{ my: 4, mx: 1 }} />
          ))}
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead sx={{ background: '#66C8E0', color: 'white' }}>
              <TableRow>
                <TableCell>
                  <RemoveRedEyeIcon />
                </TableCell>
                <TableCell>User</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Sale Date</TableCell>
                <TableCell>Description</TableCell>

                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {wastesData
                ?.slice(pg * rpg, pg * rpg + rpg)
                .map((singleSet, index) => {
                  return (
                    <React.Fragment key={index}>
                      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                        <TableCell>
                          <IconButton
                            aria-label="expand row"
                            width="0px"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRowClick(index);
                            }}>
                            {openRows[index] ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        </TableCell>
                        <TableCell>{singleSet.user.name}</TableCell>
                        <TableCell>
                          {singleSet.active == true ? 'Active' : 'In Active'}
                        </TableCell>
                        <TableCell>{singleSet.saleDate}</TableCell>
                        <TableCell sx={{ maxWidth: '110px' }}>
                          <Tooltip
                            title={
                              <Typography fontSize={15}>
                                {singleSet.desc}
                              </Typography>
                            }
                            placement="top">
                            <Typography
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontSize: '12px'
                              }}>
                              {singleSet.desc}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell
                          sx={{ display: 'flex', justifyContent: 'center' }}>
                          <Button
                            sx={{ color: '#66C8E0' }}
                            onClick={() => {
                              setOpenDialog({
                                isOpen: true,
                                id: singleSet._id
                              });
                            }}>
                            <Edit />
                          </Button>
                          {/* <Button
                            sx={{ color: '#66C8E0' }}
                            onClick={() => {
                              // setOpenDialog({ isOpen: true, id: singleSet._id });
                            }}>
                            <Delete />
                          </Button> */}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={6}>
                          <Collapse
                            in={openRows[index]}
                            timeout="auto"
                            unmountOnExit>
                            {singleSet.items.length !== 0 && (
                              <Box sx={{ margin: 1 }}>
                                <Typography
                                  variant="h5"
                                  fontWeight="700"
                                  gutterBottom
                                  component="div">
                                  Item Waste
                                </Typography>
                                <Table size="small" aria-label="purchases">
                                  <TableHead>
                                    <TableRow>
                                      <NestedTableCell>Name</NestedTableCell>
                                      <NestedTableCell>
                                        Quantity
                                      </NestedTableCell>
                                      <NestedTableCell>
                                        Description
                                      </NestedTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {singleSet.items.map(
                                      (historyRow, index) => {
                                        return (
                                          <TableRow key={index}>
                                            <TableCell>
                                              {historyRow?.ingredientSet?.name}
                                            </TableCell>
                                            <TableCell>
                                              {historyRow.quantity}
                                            </TableCell>
                                            <TableCell>
                                              {historyRow.desc}
                                            </TableCell>
                                          </TableRow>
                                        );
                                      }
                                    )}
                                  </TableBody>
                                </Table>
                              </Box>
                            )}

                            <Box sx={{ margin: 1 }}>
                              <Typography
                                variant="h5"
                                fontWeight="700"
                                gutterBottom
                                component="div">
                                Ingredients Waste
                              </Typography>
                              <Table size="small" aria-label="purchases">
                                <TableHead>
                                  <TableRow>
                                    <NestedTableCell>
                                      Ingredient
                                    </NestedTableCell>
                                    <NestedTableCell>Quantity</NestedTableCell>
                                    <NestedTableCell>Value</NestedTableCell>
                                    <NestedTableCell>Amount</NestedTableCell>
                                    <NestedTableCell>
                                      Description
                                    </NestedTableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {singleSet.ingredients.map(
                                    (historyRow, index) => {
                                      return (
                                        <TableRow key={index}>
                                          <TableCell>
                                            {historyRow?.ingredient?.name}
                                          </TableCell>
                                          <TableCell>
                                            {Number(
                                              historyRow.quantity
                                            ).toFixed(2)}
                                            <></>
                                            <b>
                                              {
                                                historyRow?.ingredient?.unit
                                                  ?.code
                                              }
                                            </b>
                                          </TableCell>
                                          <TableCell>
                                            {Math.round(historyRow.value)}
                                          </TableCell>
                                          <TableCell>
                                            {Math.round(
                                              historyRow.value *
                                                historyRow.quantity
                                            )}
                                          </TableCell>
                                          <TableCell>
                                            {historyRow.desc}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                  )}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[20, 50, 100]}
                  count={wastesData?.length || 0}
                  rowsPerPage={rpg}
                  page={pg}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <ItemWasteDialog
        openItemDialog={openItemDialog}
        setOpenItemDialog={setOpenItemDialog}
        outletId={outlet?._id}
        callFunc={callFunc}
      />

      <WasteDialog
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        outletId={outlet?._id}
        callFunc={callFunc}
      />
    </>
  );
}
